export default "__VITE_ASSET__Clj1nj1J__"